$(function() {
  $('.accordion').accordion({
      "transitionSpeed": 300,
  });
});
